import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { PageHeader, Toast } from "@/components/Layout";
import api from "@/lib/api";
import CohortsOverview from "./CohortsOverview";

const errText = (e) => e?.response?.data?.detail || "Eroare";

/** Efectivul de studenți pe program, an de studiu și an universitar — de aici se ajunge la formațiuni. */
export default function Cohorts() {
  const [params, setParams] = useSearchParams();
  const nav = useNavigate();
  const [years, setYears] = useState(null);
  const [programs, setPrograms] = useState([]);
  const [cohorts, setCohorts] = useState([]);
  const [draft, setDraft] = useState({});
  const [msg, setMsg] = useState({ text: "", type: "info" });
  const toast = (text, type = "info") => { setMsg({ text, type }); setTimeout(() => setMsg({ text: "" }), 3000); };
  const yearId = params.get("year") || (years && (years.find(y => y.is_current) || years[0] || {}).id) || "";
  const programId = params.get("program") || "";
  const overview = params.get("tab") === "ansamblu";          // „Vedere de ansamblu” (doar citire) sau „Efective și editare”
  const program = programs.find(p => p.id === programId);
  const setQ = (k, v) => { const p = new URLSearchParams(params); if (v) p.set(k, v); else p.delete(k); setParams(p); };

  useEffect(() => {
    api.get("/stat-didactic/years").then(r => setYears(r.data)).catch(() => setYears([]));
    api.get("/stat-didactic/programs").then(r => setPrograms(r.data.filter(p => p.active))).catch(() => {});
  }, []);
  const load = () => (programId && yearId)
    ? api.get("/stat-didactic/cohorts", { params: { program_id: programId, year_id: yearId } }).then(r => { setCohorts(r.data); setDraft({}); }) : setCohorts([]);
  useEffect(() => { load(); }, [programId, yearId]);

  const open = async (n) => {
    const existing = cohorts.find(c => c.study_year === n);
    const val = draft[n] !== undefined ? draft[n] : (existing ? existing.students_count : "");
    try {
      const r = await api.put("/stat-didactic/cohorts", { program_id: programId, academic_year_id: yearId, study_year: n, students_count: Number(val) || 0 });
      nav(`/stat-didactic/formatiuni/${r.data.id}`);
    } catch (e) { toast(errText(e), "error"); }
  };

  if (years === null) return <div>Se încarcă...</div>;
  if (years.length === 0) return <div className="card" style={{ padding: 24 }}>Nu există niciun an universitar. Creează-l din <Link to="/stat-didactic/ani">Ani universitari</Link>.</div>;
  const byYear = Object.fromEntries(cohorts.map(c => [c.study_year, c]));
  return (
    <>
      <PageHeader title="Formațiuni de studii" subtitle="Seriile și grupele fiecărui an de studiu, propuse din numărul de studenți și dimensiunile anului universitar" />
      <Toast msg={msg.text} type={msg.type} />
      <div style={{ display: "flex", gap: 8, marginBottom: 14 }} role="tablist">
        <button className={"btn " + (overview ? "btn-secondary" : "btn-primary")} onClick={() => setQ("tab", "")} data-testid="sfd-coh-tab-edit">Efective și editare</button>
        <button className={"btn " + (overview ? "btn-primary" : "btn-secondary")} onClick={() => setQ("tab", "ansamblu")} data-testid="sfd-coh-tab-overview">Vedere de ansamblu</button>
      </div>
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
        <div><label className="label">An universitar</label>
          <select className="select" value={yearId} onChange={e => setQ("year", e.target.value)} data-testid="sfd-coh-year">
            {years.map(y => <option key={y.id} value={y.id}>{y.name}{y.is_current ? " (curent)" : ""}</option>)}</select></div>
        <div style={{ minWidth: 280 }}><label className="label">Program de studii</label>
          <select className="select" value={programId} onChange={e => setQ("program", e.target.value)} data-testid="sfd-coh-program">
            <option value="">{overview ? "— toate programele —" : "— alege —"}</option>{programs.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}</select></div>
      </div>
      {overview ? <CohortsOverview yearId={yearId} programId={programId} /> : !program ? (
        <div className="card" style={{ padding: 24, color: "#64748B" }}>{programs.length === 0 ? <>Nu există programe de studii. Adaugă-le din <Link to="/stat-didactic/programe">Programe de studii</Link>.</> : "Alege un program."}</div>
      ) : (
        <div className="card">
          <table className="tbl">
            <thead><tr><th>An de studiu</th><th>Studenți (efectiv)</th><th>Formațiuni</th><th></th></tr></thead>
            <tbody>{Array.from({ length: program.duration_years }, (_, i) => i + 1).map(n => {
              const c = byYear[n];
              return (
                <tr key={n} data-testid={`sfd-coh-row-${n}`}>
                  <td style={{ fontWeight: 700 }}>Anul {n}</td>
                  <td><input className="input" type="number" min="0" style={{ width: 110 }} value={draft[n] !== undefined ? draft[n] : (c ? c.students_count : "")}
                    onChange={e => setDraft({ ...draft, [n]: e.target.value })} data-testid={`sfd-coh-students-${n}`} placeholder="0" /></td>
                  <td>{c ? (c.series + c.groups > 0 ? `${c.series} serii, ${c.groups} grupe` : <span style={{ color: "#94A3B8" }}>nepropuse încă</span>) : <span style={{ color: "#94A3B8" }}>—</span>}</td>
                  <td style={{ textAlign: "right" }}><button className="btn btn-primary" style={{ padding: "3px 10px", fontSize: 12 }} onClick={() => open(n)} data-testid={`sfd-coh-open-${n}`}>{c ? "Deschide formațiunile" : "Salvează și continuă"}</button></td>
                </tr>);
            })}</tbody>
          </table>
        </div>
      )}
    </>
  );
}
